import React from 'react';
import { TI_STATUSES } from '../../triage/config';
import type { TriageStatus } from '../../triage/types';

export interface TriageStatusPillProps {
  status: TriageStatus;
  size?: 'small' | 'default' | 'large';
  className?: string;
  style?: React.CSSProperties;
}

export function TriageStatusPill({ status, size = 'default', className, style }: TriageStatusPillProps) {
  const s = TI_STATUSES[status] ?? TI_STATUSES.open!;
  const sizeStyles =
    size === 'small'
      ? { fontSize: 10, padding: '1px 7px' }
      : size === 'large'
        ? { fontSize: 12, padding: '3px 10px' }
        : { fontSize: 11, padding: '2px 9px' };
  const dotSize = size === 'small' ? 5 : 7;

  return (
    <span
      className={`ti-status-pill ${className ?? ''}`}
      style={{ background: s.bg, color: s.color, ...sizeStyles, ...style }}
    >
      <span
        className="ti-status-dot"
        style={{ background: s.dot, width: dotSize, height: dotSize }}
      />
      {s.shortLabel}
    </span>
  );
}
